import React from 'react';
import { ArrowLeft, UserPlus, Users, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { useToast } from '../ToastContext';
interface ScanScreenProps {
  onBack: () => void;
}
export function ScanScreen({
  onBack
}: ScanScreenProps) {
  const {
    showToast
  } = useToast();
  const handleSimulateScan = () => {
    showToast('Scanned! Friend added to your contacts 🎉', 'success');
    setTimeout(() => {
      onBack();
    }, 1500);
  };
  return <div className="flex flex-col h-full bg-gray-900 overflow-hidden relative" data-id="element-1709">
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 z-10 p-6 flex items-center justify-between bg-gradient-to-b from-black/80 to-transparent" data-id="element-1710">
        <button onClick={onBack} className="w-10 h-10 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" data-id="element-1711">
          <ArrowLeft size={20} className="text-white" data-id="element-1712" />
        </button>
        <h1 className="text-lg font-bold text-white" data-id="element-1713">Scan QR Code</h1>
        <div className="w-10" data-id="element-1714" /> {/* Spacer for centering */}
      </div>

      {/* Scanner Viewfinder */}
      <div className="flex-1 flex flex-col items-center justify-center px-6" data-id="element-1715">
        <div className="relative w-64 h-64 mb-12" data-id="element-1716">
          {/* Corner Brackets */}
          <div className="absolute top-0 left-0 w-12 h-12 border-t-4 border-l-4 border-white rounded-tl-2xl" data-id="element-1717" />
          <div className="absolute top-0 right-0 w-12 h-12 border-t-4 border-r-4 border-white rounded-tr-2xl" data-id="element-1718" />
          <div className="absolute bottom-0 left-0 w-12 h-12 border-b-4 border-l-4 border-white rounded-bl-2xl" data-id="element-1719" />
          <div className="absolute bottom-0 right-0 w-12 h-12 border-b-4 border-r-4 border-white rounded-br-2xl" data-id="element-1720" />

          {/* Animated Scan Line */}
          <motion.div className="absolute left-0 right-0 h-0.5 bg-[#FFFC00] shadow-[0_0_15px_#FFFC00]" animate={{
          top: ['0%', '100%', '0%']
        }} transition={{
          duration: 3,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-1721" />

          {/* Dark overlay outside viewfinder (simulated with box-shadow) */}
          <div className="absolute inset-0 shadow-[0_0_0_9999px_rgba(0,0,0,0.6)] rounded-2xl pointer-events-none" data-id="element-1722" />
        </div>

        {/* Action Chips */}
        <div className="w-full max-w-xs space-y-3 relative z-10" data-id="element-1723">
          <p className="text-center text-white/70 text-sm mb-4" data-id="element-1724">
            Point your camera at a QR code to:
          </p>

          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md p-3 rounded-xl border border-white/10" data-id="element-1725">
            <div className="w-10 h-10 rounded-full bg-[#FFFC00]/20 flex items-center justify-center flex-shrink-0" data-id="element-1726">
              <UserPlus size={20} className="text-[#FFFC00]" data-id="element-1727" />
            </div>
            <div className="flex-1" data-id="element-1728">
              <p className="text-white font-medium text-sm" data-id="element-1729">Add Friend</p>
              <p className="text-white/60 text-xs" data-id="element-1730">Scan their profile QR</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md p-3 rounded-xl border border-white/10" data-id="element-1731">
            <div className="w-10 h-10 rounded-full bg-[#FFFC00]/20 flex items-center justify-center flex-shrink-0" data-id="element-1732">
              <Users size={20} className="text-[#FFFC00]" data-id="element-1733" />
            </div>
            <div className="flex-1" data-id="element-1734">
              <p className="text-white font-medium text-sm" data-id="element-1735">Join Group</p>
              <p className="text-white/60 text-xs" data-id="element-1736">Scan group order QR</p>
            </div>
          </div>

          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md p-3 rounded-xl border border-white/10" data-id="element-1737">
            <div className="w-10 h-10 rounded-full bg-[#FFFC00]/20 flex items-center justify-center flex-shrink-0" data-id="element-1738">
              <MapPin size={20} className="text-[#FFFC00]" data-id="element-1739" />
            </div>
            <div className="flex-1" data-id="element-1740">
              <p className="text-white font-medium text-sm" data-id="element-1741">Check In</p>
              <p className="text-white/60 text-xs" data-id="element-1742">Scan store QR code</p>
            </div>
          </div>
        </div>
      </div>

      {/* Simulate Button */}
      <div className="p-6 relative z-10 bg-gradient-to-t from-black to-transparent" data-id="element-1743">
        <button onClick={handleSimulateScan} className="w-full py-4 bg-[#FFFC00] text-black rounded-xl font-bold text-lg active:scale-95 transition-transform shadow-lg" data-id="element-1744">
          Simulate Scan
        </button>
      </div>
    </div>;
}